import ConfirmationBlock from './ConfirmationBlock';

export default ConfirmationBlock;
